module.exports = __webpack_public_path__ + "img/gift_top_three.44d0c209.png";